"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The EdelmetallKinds model module.
 * @module model/EdelmetallKinds
 * @version 1.0.44
 */
var EdelmetallKinds = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>EdelmetallKinds</code>.
   * Art des Edelmetalls
   * @alias module:model/EdelmetallKinds
   */
  function EdelmetallKinds() {
    _classCallCheck(this, EdelmetallKinds);
    EdelmetallKinds.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(EdelmetallKinds, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>EdelmetallKinds</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EdelmetallKinds} obj Optional instance to populate.
     * @return {module:model/EdelmetallKinds} The populated <code>EdelmetallKinds</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new EdelmetallKinds();
        if (data.hasOwnProperty('gold')) {
          obj['gold'] = _ApiClient.default.convertToType(data['gold'], 'String');
        }
        if (data.hasOwnProperty('silver')) {
          obj['silver'] = _ApiClient.default.convertToType(data['silver'], 'String');
        }
        if (data.hasOwnProperty('platinum')) {
          obj['platinum'] = _ApiClient.default.convertToType(data['platinum'], 'String');
        }
        if (data.hasOwnProperty('palladium')) {
          obj['palladium'] = _ApiClient.default.convertToType(data['palladium'], 'String');
        }
        if (data.hasOwnProperty('other')) {
          obj['other'] = _ApiClient.default.convertToType(data['other'], 'String');
        }
        if (data.hasOwnProperty('additionalProperties')) {
          obj['additionalProperties'] = _ApiClient.default.convertToType(data['additionalProperties'], Object);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EdelmetallKinds</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EdelmetallKinds</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['gold'] && !(typeof data['gold'] === 'string' || data['gold'] instanceof String)) {
        throw new Error("Expected the field `gold` to be a primitive type in the JSON string but got " + data['gold']);
      }
      // ensure the json data is a string
      if (data['silver'] && !(typeof data['silver'] === 'string' || data['silver'] instanceof String)) {
        throw new Error("Expected the field `silver` to be a primitive type in the JSON string but got " + data['silver']);
      }
      // ensure the json data is a string
      if (data['platinum'] && !(typeof data['platinum'] === 'string' || data['platinum'] instanceof String)) {
        throw new Error("Expected the field `platinum` to be a primitive type in the JSON string but got " + data['platinum']);
      }
      // ensure the json data is a string
      if (data['palladium'] && !(typeof data['palladium'] === 'string' || data['palladium'] instanceof String)) {
        throw new Error("Expected the field `palladium` to be a primitive type in the JSON string but got " + data['palladium']);
      }
      // ensure the json data is a string
      if (data['other'] && !(typeof data['other'] === 'string' || data['other'] instanceof String)) {
        throw new Error("Expected the field `other` to be a primitive type in the JSON string but got " + data['other']);
      }
      return true;
    }
  }]);
}();
/**
 * Gold
 * @member {String} gold
 */
EdelmetallKinds.prototype['gold'] = undefined;

/**
 * Silber
 * @member {String} silver
 */
EdelmetallKinds.prototype['silver'] = undefined;

/**
 * Platin
 * @member {String} platinum
 */
EdelmetallKinds.prototype['platinum'] = undefined;

/**
 * Paladium
 * @member {String} palladium
 */
EdelmetallKinds.prototype['palladium'] = undefined;

/**
 * Sonstige
 * @member {String} other
 */
EdelmetallKinds.prototype['other'] = undefined;

/**
 * @member {Object} additionalProperties
 */
EdelmetallKinds.prototype['additionalProperties'] = undefined;
var _default = exports.default = EdelmetallKinds;